import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  RESCHEDULE_CLASSES_STAGES,
  rescheduleClassesStageSelector,
} from 'features/classCreation';
import RescheduleClassesTypeChip from '../RescheduleClassesTypeChip';
import RescheduleFilterSection from '../RescheduleFilterSection';

export default function RescheduleClassesFilters() {
  const stage = useSelector(rescheduleClassesStageSelector);

  if (stage === RESCHEDULE_CLASSES_STAGES.view) {
    return (
      <div className="m-v-s">
        <Icon
          name="filter-alt"
          className="p-t-xxs m-r-xxs h5"
        />
        <label className="dark bold">Filters</label>
        <RescheduleFilterSection />
      </div>
    );
  } else {
    return <RescheduleClassesTypeChip />;
  }
}
